// extracted by mini-css-extract-plugin
module.exports = {"container":"ValetMarkContent_container__1dAxn","mark":"ValetMarkContent_mark__3oHar","markAppend":"ValetMarkContent_markAppend__2C_4h"};